import {
  CREATE_PVS_REQUEST,
  CREATE_PVS_SUCCESS,
  CREATE_PVS_FAILURE,
  RESET_PVS_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const createPvsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PVS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case CREATE_PVS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "PVS created successfully",
      };

    case CREATE_PVS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to create PVS",
      };

    case RESET_PVS_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createPvsReducer;
